import { CardMedia, Tooltip, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import CustomIconify from 'src/features/components/customIconify';
import { Animate } from 'src/features/global/styles';
import {
  Container,
  ContainerImage,
  ContentContainer,
  DashedDivider,
  SocialMediaContainer,
  SocialMidiaIcon,
} from './styles';

// -----------------------------------------------------------------------------------------

export default function Footer() {
  return (
    <Container>
      <ContentContainer id="Session 1">
        <ContainerImage>
          <CardMedia
            component="img"
            alt="Logo do Footer"
            image="images/logo.webp"
            width={200}
            height={200}
          />
          <div>
            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>
              &copy; 2024 - {new Date().getFullYear()}
            </p>

            <p style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '-20px' }}>
              Todos os direitos reservados
            </p>
          </div>
        </ContainerImage>
      </ContentContainer>

      <DashedDivider orientation="vertical" />

      <ContentContainer id="Session 2">
        <SocialMediaContainer>
          <Typography gutterBottom variant="h5" component="div" align="center">
            Siga-nos nas redes sociais
          </Typography>

          <SocialMidiaIcon>
            <Animate>
              <CustomIconify
                icon="skill-icons:instagram"
                href="https://www.instagram.com/pafesan.toldos/"
                label="Instagram"
              />
            </Animate>
            <Animate>
              <CustomIconify
                icon="logos:facebook"
                href="https://www.facebook.com/profile.php?id=61556556355243"
                label="Facebook"
              />
            </Animate>
          </SocialMidiaIcon>
        </SocialMediaContainer>
      </ContentContainer>

      <DashedDivider orientation="vertical" />

      <ContentContainer id="Session 3">
        <Typography
          gutterBottom
          variant="body1"
          component="div"
          align="center"
          mt={5}
          style={{ fontWeight: 'bold' }}
        >
          Desenvolvido por:{' '}
          <a
            href="https://www.fullcodedev.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="Acessar Full Code Tecnologia"
            hidden
          >
            Full Code Tecnologia{' '}
          </a>
        </Typography>

        <Animate>
          <Link to="https://www.fullcodedev.com" target="_blank" rel="noopener noreferrer">
            <ContainerImage>
              <Tooltip title="Clique aqui e conheça o desenvolvedor">
                <CardMedia
                  component="img"
                  alt="Logo do Desenvolvedor"
                  image="images/fullcode.png"
                  width="auto"
                  height="auto"
                />
              </Tooltip>
            </ContainerImage>
          </Link>
        </Animate>
      </ContentContainer>
    </Container>
  );
}
